import React from 'react'
import Button from '../../components/ui/button/Button'
import { ListFilter, Plus, X } from 'lucide-react'
import { useBusiness } from '../../context/BusinessContext'
import Notify from '../../components/common/Notify'
import { useCreate } from '../../context/CreateRegisterContext'
import Tooltip from '../../components/common/Tooltip'
const BusinessAddButton = () => {
    const { setOpenFilter, totalFilters, clearFilters } = useBusiness()
    const { openBusiness, setOpenBusiness } = useCreate()

    return (
        <Tooltip label='Adicionar negócio'>
            <Button
                variant='primary'
                size='sm'
                onClick={() => setOpenBusiness(true)}
                startIcon={<Plus className='w-4 h-4' />}
            >
                Adicionar
            </Button>
        </Tooltip>
    )
}

export default BusinessAddButton
